var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"success","href":_vm.url,"download":"","depressed":"","disabled":_vm.isDisabled}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-download")]),_vm._v(" Download Lead Stats ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }